<template>
  <div>
    <div
      class="page-content__header-description"
      style="display: flex; margin-bottom: 20px;"
    >
      <h2 style="">
        Customer Onboarding Verification
      </h2>
    </div>
    <div class="main-container onboarding-page">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <div style="width: 100%">
                <div v-show="showInitLoading">
                  <animated-spinner></animated-spinner>
                </div>
                <h3 class="pagin_style">
                  Showing
                  {{
                    paginationInfo.total > 0
                      ? `${paginationInfo.first} - ${paginationInfo.last}
            ${paginationInfo.ofText} ${paginationInfo.total} ${
                          paginationInfo.total > 1 ? "Devices" : "Device"
                        }`
                      : "no device"
                  }}
                </h3>
                <el-input
                  style="width: 30%"
                  class="el-input el-input--prefix"
                  placeholder="Type Customers ID"
                  prefix-icon="el-icon-search"
                  v-model="searchTerm"
                  v-if="!showLoading"
                ></el-input>
                <div style="width: 100%">
                  <vue-good-table
                    :lineNumbers="true"
                    :columns="fields"
                    :rows="getUsers"
                    :key="getUsers.id"
                    :search-options="{
                      enabled: true,
                      searchFn: searchTable,
                      externalQuery: searchTerm
                    }"
                    :pagination-options="{ enabled: true }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'firstname'">
                        {{ props.row.firstname ? props.row.firstname : "----" }}
                        {{ props.row.lastname ? props.row.lastname : "----" }}
                        ({{ props.row.username ? props.row.username : "----" }})
                      </span>

                      <span v-if="props.column.field == 'identity_doc'">
                        <a
                          :href="props.row.utility_file"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{
                            props.row.utility_doc
                              ? props.row.utility_doc
                              : "----"
                          }}</a
                        >
                        |
                        <a
                          :href="props.row.moi_file"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ props.row.moi ? props.row.moi : "----" }}</a
                        >
                      </span>
                      <span v-if="props.column.field == 'status'">
                        {{ props.row.status ? props.row.status : "----" }}
                      </span>

                      <span v-else-if="props.column.field == 'createdat'">
                        {{ formatDate(props.row.createdat) }}
                      </span>

                      <span v-if="props.column.field == 'contract'">
                        <span v-if="!props.row.contract">---</span>
                        <a :href="props.row.contract" target="_blank" v-else
                          >Download Contract</a
                        >
                      </span>

                      <span v-if="props.column.field == 'approved'">
                        {{ "---" }}
                      </span>

                      <span v-if="props.column.field == 'actions'">
                        <div class="action_style">
                          <!-- <a-dropdown :trigger="['click']">
                    <p class="ant-dropdown-link ellipsis_style">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </p>
                  </a-dropdown> -->
                          <div v-if="!props.row.contract"></div>
                          <template v-else-if="props.row.status !== 'approved'">
                            <template>
                              <a-button
                                @click="
                                  showApproveContractModalFunc(
                                    props.row.customerid
                                  )
                                "
                              >
                                <i class="fas fa-edit"> Approve </i>
                              </a-button>
                              <a-modal
                                v-model="showApproveContractModal"
                                title="Approve Contract"
                                @ok="handleApproveContractOk"
                                :confirm-loading="showLoading"
                                @cancel="handleApproveContractCancel"
                              >
                                <a-upload
                                  :action="uploadUrl"
                                  @change="handleChange"
                                  @drop="handleDrop"
                                >
                                  <p>
                                    Kindly upload your countersigned contract
                                  </p>
                                  <a-button>
                                    <a-icon type="upload" /> Click to Upload
                                  </a-button>
                                </a-upload>
                              </a-modal>
                            </template>
                            <template>
                              <a-button
                                @click="
                                  showDeclineContractModalFunc(
                                    props.row.customerid
                                  )
                                "
                              >
                                <i class="fas fa-edit"> Decline </i>
                              </a-button>
                              <a-modal
                                v-model="showDeclineContractModal"
                                title="Decline Contract"
                                @ok="handleDeclineContractOk"
                                :confirm-loading="showLoading"
                                @cancel="handleDeclineContractCancel"
                              >
                                <p>Decline reason</p>
                                <textarea
                                  class="form-control form-control-md"
                                  v-model="comment"
                                  cols="30"
                                  rows="2"
                                ></textarea>
                              </a-modal>
                            </template>
                          </template>

                          <!-- <template>
                    <a-button @click="DO_DECLINE">
                      <i class="fa fa-trash"> Decline</i>
                    </a-button>
                  </template> -->
                        </div>
                      </span>
                    </template>

                    <template slot="pagination-bottom" slot-scope="props">
                      <grey-pagination
                        :total="props.total"
                        :pageChanged="props.pageChanged"
                        :perPageChanged="props.perPageChanged"
                        @paginated-info="paginationInfo = $event"
                      ></grey-pagination>
                    </template>
                  </vue-good-table>
                </div>

                <modal
                  width="500px"
                  height="auto"
                  name="my-first-modal"
                  style="border-radius: 28px !important"
                  class="first-modal"
                >
                  <div class="form">
                    <form name="myForm">
                      <p class="triangle">
                        <i
                          class="fa fa-exclamation-triangle fa-3x"
                          style="color:red; background-color: pink; border-radius: 50%; width: 45px; height: 47px; margin: 16px;"
                          aria-hidden="true"
                        ></i>
                      </p>
                      <h4>
                        {{ "Auto Populate this text here" }}
                      </h4>
                      <p style="text-align: center;">"{{ userName }}"</p>

                      <div class="row">
                        <button
                          type="submit"
                          class="button-cancel"
                          @click="cancel"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          class="button-delete"
                          @click.prevent=""
                        >
                          YES
                        </button>
                      </div>
                    </form>
                  </div>
                </modal>
              </div>
            </can>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";
import { Modal, Button, Upload, Icon } from "ant-design-vue";
import { message } from "ant-design-vue";
import { ONBOARDING_URL } from "@/utils/http-common.js";

const items = [];
export default {
  name: "ListOnboardingTracker",
  components: {
    "a-upload": Upload,
    "animated-spinner": AnimatedSpinnerLoader,
    "a-button": Button,
    "a-icon": Icon,
    "a-modal": Modal,
    "a-button": Button,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  props: {
    dateRange: {
      type: Object,
      required: true
    }
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  watch: {
    dateRange: {
      handler: "init",
      immediate: true
    }
  },
  data() {
    return {
      paginationInfo: {},
      showUpdate: false,
      showLoading: false,
      showInitLoading: false,
      showApproveContractModal: false,
      showDeclineContractModal: false,
      paginatedInfo: {},
      searchTerm: "",
      userName: "",
      items: items,

      fields: [
        {
          field: "firstname",
          label: "First Name",
          sortable: "true",
          width: "20%"
        },
        {
          field: "identity_doc",
          label: "Document 1 | Document 2",
          width: "30%"
        },
        {
          field: "contract",
          label: "Contract",
          width: "20%"
        },
        {
          field: "status",
          label: "Status",
          width: "10%"
        },
        {
          label: "Created At",
          field: "createdat",
          sortable: true
        },
        {
          field: "actions",
          label: "",
          width: "20%"
        }
      ],
      getUsers: "",
      status: "",
      currentPage: 1,
      customerId: null,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      uploaded_pdf_url: "",
      comment: "",
      uploadUrl: `${ONBOARDING_URL}/kycfiles/s3-file-upload`
    };
  },
  computed: {
    ...mapGetters(["getUsers"])
  },
  methods: {
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.uploaded_pdf_url = info.file.response.url;
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleDrop(e) {
      console.log(e);
    },
    showApproveContractModalFunc(customerId) {
      this.customerId = customerId;
      this.showApproveContractModal = true;
      this.status = "approved";
    },
    showDeclineContractModalFunc(customerId) {
      this.customerId = customerId;
      this.showDeclineContractModal = true;
      this.status = "decline";
    },
    async handleApproveContractOk() {
      if (!this.uploaded_pdf_url) {
        message.error(`Kindly upload signed contract to continue.`);
        return;
      }
      try {
        this.showLoading = true;
        const res = await this.updateDBData({
          customer: this.customerId,
          status: this.status,
          contract: this.uploaded_pdf_url
        });
        if (res.status == 200) {
          this.showApproveContractModal = false;
          this.init();
        }
      } catch (error) {
        this.showLoading = false;
        console.error("Error: ", error);
      }
    },
    async handleDeclineContractOk(e) {
      if (!this.comment) {
        message.error(`Kindly add decline reason or comment.`);
        return;
      }
      try {
        this.showLoading = true;
        const res = await this.updateDBData({
          customer: this.customerId,
          status: this.status,
          comment: this.comment
        });
        if (res.status == 200) {
          this.showDeclineContractModal = false;
          this.init();
        }
      } catch (error) {
        this.showLoading = false;
        console.error("Error: ", error);
      }
    },
    handleApproveContractCancel() {
      this.showApproveContractModal = false;
    },
    handleDeclineContractCancel() {
      this.showDeclineContractModal = false;
    },

    async updateDBData(data) {
      const HTTP = this.$httpUtils.FASTHTTP;
      return HTTP.post("/kycfiles/admin-update-contract", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`
        }
      });
    },
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    cancel() {
      this.hide();
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    init() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = `/onboardingstate/state-with-files?start_date=${this.dateRange.start}&end_date=${this.dateRange.end}`;
      this.showInitLoading = true;

      HTTP.get(url)
        .then(response => {
          this.getUsers = response.data.data;
          this.showInitLoading = false;
        })
        .catch(error => {
          this.showInitLoading = false;
          this.showErrorMsg({ message: "Error occurred at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.main-container {
  padding: 0;
}
a:hover {
  color: blue;
  text-decoration: underline;
}

.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.pagin_style {
  color: #85878d;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
.el-input__inner {
  border-radius: 10px;
  /* width: 360px; */
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.triangle {
  /* background-color: red; */
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.button-delete:hover {
  padding: 5px;
  color: white;
  border-color: rgb(146, 1, 1);
  background: rgb(146, 1, 1);
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 49%;
  border-radius: 8px;
}

.button-cancel:hover {
  padding: 5px;
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
  width: 49%;
  border-radius: 8px;
}

table th,
table th span {
  font-size: 0.7em;
}
.onboarding-page {
  height: calc(100vh - 250px);
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
.action_style {
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/ListOnboardingTracker.vue